function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { useEffect, useCallback } from "react";
import ReactGA from "react-ga4";
import useData from "./data";
// config and clients will be provided via props
import DealSection from "./Components/DealSection";
import BundleOffers from "./Components/BundleOffers";
import DealsCategory from "./Components/DealsCategory";
import Header from "./Components/Header";
import CategoryDropdown from "./Components/CategoryDropdown";
import Vendors from "./Components/Vendors";
import { getFont } from "../../utils/helpers";
import { isAdani, isMahindra, isAloha } from "../../utils/isClient";
import SkeletonDealPage from "../Common/Skeleton/SkeletonDealPage";
import { scrollToTargetAdjusted } from "../../utils/ui";
// Redux hooks removed; values will come via props
// import Modal from "../../Components/Organisms/Modal";
// import {
//   filterSvg,
//   loadMoreSvg,
//   noDealsvg,
// } from "./Components/ProductListing/svg";
// import ZeroDeals from "./Components/ZeroDeals";
// HTTP clients removed from direct imports; will come via props
// import TotalRewards from "../ReferralPage/TotalRewards";
import FAQSection from "./Components/RewardQandA";
import _, { isNaN } from "lodash";
// import SearchBar from "../../Components/Organisms/SearchBar";
import KYCModal from "../Common/KYCModal";
import useKYC from "../../Hooks/use-KYC";
import useBookingSummary from "../../Hooks/use-bookingSummary";
// Actions will be passed via props.redux

// import SideModal from "../../Components/Organisms/SideModal";
// Router values will be provided via props
// import { toast } from "react-toastify";
import BasketFull from "./Components/BasketFull";
import AmazonWishlistInput from "./Components/AmazonWishlistInput";
import ZeroRewardPoints from "./Components/ZeroRewardPoints";
import ZeroState from "../Common/ZeroState";
import GrClose from "@meronex/icons/gr/GrClose";
import RewardsPopupModal from "../Common/RewardsPopupModal";
import { isReloy } from "../../utils/isClient";
import ReloyPointsGuide from "../PointSystem/ReloyPointsGuide";
import FooterBenefit from "../PointSystem/FooterBenefits";
import HowToEarnCoins from "../PointSystem/HowToEarnCoins";
import RedeemSteps from "../PointSystem/RedeemSteps";
import CoinStoreHeader from "../PointSystem/CoinStoreHeader";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function DealsAndDiscounts(_ref) {
  var _authState$isAuthenti, _ref2, _redux$showRewardsMod, _redux$deal, _redux$deals, _redux$isRefreshRewar, _ref3, _redux$isKycModalEnab, _redux$deal2, _redux$deals2, _config$sectionBackgr, _config$sectionBackgr2, _config$sectionBackgr3, _config$sectionBackgr4, _config$sectionBackgr5, _config$sectionBackgr6, _config$sectionBackgr7, _config$sectionBackgr8, _config$deals;
  var isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    config = _ref.config,
    cmsClient = _ref.cmsClient,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    appType = _ref.appType,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    _ref$showAppDownload = _ref.showAppDownload,
    showAppDownload = _ref$showAppDownload === void 0 ? false : _ref$showAppDownload,
    isMonsoonClient = _ref.isMonsoonClient;
  var _useData = useData({
      isRewards: isRewards,
      isPoints: isPoints,
      config: config,
      cmsClient: cmsClient,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth,
      appType: appType,
      redux: redux,
      router: router
    }),
    bundleOffers = _useData.bundleOffers,
    topOffers = _useData.topOffers,
    homeServicesOffers = _useData.homeServicesOffers,
    homeFurnishingOffers = _useData.homeFurnishingOffers,
    lifestyleOffers = _useData.lifestyleOffers,
    electronicsOffers = _useData.electronicsOffers,
    financeOffers = _useData.financeOffers,
    externalOffers = _useData.externalOffers,
    digitalAmenities = _useData.digitalAmenities,
    vendors = _useData.vendors,
    isLoadingTopDeals = _useData.isLoadingTopDeals,
    isLoadingHomeServices = _useData.isLoadingHomeServices,
    isLoadingHomeFurnishing = _useData.isLoadingHomeFurnishing,
    isLoadingLifestyle = _useData.isLoadingLifestyle,
    isLoadingElectronics = _useData.isLoadingElectronics,
    isLoadingFinance = _useData.isLoadingFinance,
    isLoadingDigital = _useData.isLoadingDigital,
    kycStatus = _useData.kycStatus,
    error = _useData.error,
    handleChange = _useData.handleChange,
    searchInput = _useData.searchInput,
    isLoadingBundle = _useData.isLoadingBundle,
    rewards = _useData.rewards,
    isLoadingrewards = _useData.isLoadingrewards,
    getRewards = _useData.getRewards,
    isRewardsLoaded = _useData.isRewardsLoaded,
    totalRewardspoint = _useData.totalRewardspoint,
    rewardsCategoryList = _useData.rewardsCategoryList,
    selectedRewardCategory = _useData.selectedRewardCategory,
    setSelectedRewardCategory = _useData.setSelectedRewardCategory,
    selectedTag = _useData.selectedTag,
    handleCategorySelection = _useData.handleCategorySelection,
    handleTagSelection = _useData.handleTagSelection,
    totalPages = _useData.totalPages,
    setCurrentPage = _useData.setCurrentPage,
    currentPage = _useData.currentPage,
    loadMoreHandler = _useData.loadMoreHandler;
  // console.log("searchInput Length", searchInput.length);
  // console.log("financeOffers", financeOffers);
  // account for redux shape differences (some apps put auth under
  // redux.auth; others flatten).  mirrors normalization used in the data
  // hook above.
  var authState = (redux === null || redux === void 0 ? void 0 : redux.auth) || {};
  var isAuthenticated = (_authState$isAuthenti = authState.isAuthenticated) !== null && _authState$isAuthenti !== void 0 ? _authState$isAuthenti : redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var dealAction = (redux === null || redux === void 0 ? void 0 : redux.dealAction) || {};
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  console.log("config?.darkTheme", config === null || config === void 0 ? void 0 : config.darkTheme);
  console.log("isPoints inside deal and discount", isPoints);
  var _useBookingSummary = useBookingSummary({
      redux: {
        isAuthenticated: isAuthenticated,
        dispatch: dispatch,
        authActions: authActions
      },
      winnreAuth: winnreAuth,
      appType: appType,
      isPoints: isPoints
    }),
    userAccountSummary = _useBookingSummary.userAccountSummary,
    getUserAccountSummary = _useBookingSummary.getUserAccountSummary;
  var showRewardsModal = (_ref2 = (_redux$showRewardsMod = redux === null || redux === void 0 ? void 0 : redux.showRewardsModal) !== null && _redux$showRewardsMod !== void 0 ? _redux$showRewardsMod : redux === null || redux === void 0 || (_redux$deal = redux.deal) === null || _redux$deal === void 0 ? void 0 : _redux$deal.showRewardsModal) !== null && _ref2 !== void 0 ? _ref2 : redux === null || redux === void 0 || (_redux$deals = redux.deals) === null || _redux$deals === void 0 ? void 0 : _redux$deals.showRewardsModal;
  var location = (router === null || router === void 0 ? void 0 : router.location) || {};
  var deals = (redux === null || redux === void 0 ? void 0 : redux.deals) || (redux === null || redux === void 0 ? void 0 : redux.deal) || {};
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    replace: function replace() {},
    push: function push() {}
  };
  var _useKYC = useKYC({
      router: {
        history: history,
        location: location
      },
      config: config,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth,
      cmsClient: cmsClient,
      redux: {
        dispatch: dispatch,
        dealAction: redux === null || redux === void 0 ? void 0 : redux.dealAction
      }
    }),
    step = _useKYC.step,
    setStep = _useKYC.setStep,
    setError = _useKYC.setError,
    showError = _useKYC.showError,
    checkKycVerificationStatus = _useKYC.checkKycVerificationStatus,
    closeKYCModal = _useKYC.closeKYCModal,
    setOpenKYCModal = _useKYC.setOpenKYCModal,
    openKYCModal = _useKYC.openKYCModal,
    loading = _useKYC.loading,
    checkBankVerificationStatus = _useKYC.checkBankVerificationStatus,
    isUpdateWorkflow = _useKYC.isUpdateWorkflow,
    isKycCompleted = _useKYC.isKycCompleted,
    initiateWorkflow = _useKYC.initiateWorkflow,
    claimInProgress = _useKYC.claimInProgress,
    rewardTypeSelected = _useKYC.rewardTypeSelected,
    cashOutFlow = _useKYC.cashOutFlow,
    setClaimInProgress = _useKYC.setClaimInProgress,
    bankstatus = _useKYC.bankstatus,
    isKycFailed = _useKYC.isKycFailed,
    isBankVerificationFailed = _useKYC.isBankVerificationFailed,
    isKycProcessing = _useKYC.isKycProcessing;
  var isRewardRefreshing = (_redux$isRefreshRewar = redux === null || redux === void 0 ? void 0 : redux.isRefreshRewards) !== null && _redux$isRefreshRewar !== void 0 ? _redux$isRefreshRewar : redux === null || redux === void 0 ? void 0 : redux.isRewardRefreshing;
  var isKycModalEnabled = (_ref3 = (_redux$isKycModalEnab = redux === null || redux === void 0 ? void 0 : redux.isKycModalEnabled) !== null && _redux$isKycModalEnab !== void 0 ? _redux$isKycModalEnab : redux === null || redux === void 0 || (_redux$deal2 = redux.deal) === null || _redux$deal2 === void 0 ? void 0 : _redux$deal2.isKycModalEnabled) !== null && _ref3 !== void 0 ? _ref3 : redux === null || redux === void 0 || (_redux$deals2 = redux.deals) === null || _redux$deals2 === void 0 ? void 0 : _redux$deals2.isKycModalEnabled;
  // const [openFilter, setOpenFilter] = useState(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    noRewards = _useState2[0],
    setNorewards = _useState2[1];
  var internalWebview = redux === null || redux === void 0 ? void 0 : redux.internalWebview;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  useEffect(function () {
    // Function to check screen size
    var checkMobile = function checkMobile() {
      setIsMobile(window.innerWidth < 1024); // Adjust the width as per your design
    };

    // Initial check
    checkMobile();

    // Event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Clean up the event listener on component unmount
    return function () {
      return window.removeEventListener("resize", checkMobile);
    };
  }, []);
  var closeModal = function closeModal() {
    closeKYCModal();
    getUserAccountSummary();
  };
  var onClickCategoryFilter = function onClickCategoryFilter(categoryId) {
    handleCategorySelection(categoryId);
    history.replace({
      pathname: location.pathname // Keeps the same page without params
    });
  };
  var onClickTagFilter = function onClickTagFilter(tagId, categoryId) {
    handleTagSelection(tagId, categoryId);
    history.replace({
      pathname: location.pathname // Keeps the same page without params
    });
  };
  var claimNowHandler = function claimNowHandler(forceInitate, silentCheck, cashoutProcess) {
    if (!isAuthenticated) {
      if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
        dispatch(authActions.openLoginModal());
      }
      return;
    }
    checkKycVerificationStatus(forceInitate, silentCheck, cashoutProcess);
    setOpenKYCModal(true);
    setError(null);
  };
  useEffect(function () {
    var _window, _cmsClient$defaults, _cmsClient$defaults2;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("DealPageViewed", {
      Section: isRewards ? "Store" : "Offers"
    });
    // window?.webengage?.track('DealPageViewed');
    if ((cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults = cmsClient.defaults) === null || _cmsClient$defaults === void 0 ? void 0 : _cmsClient$defaults.baseURL) === "https://prod.loyalie.in" || (cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults2 = cmsClient.defaults) === null || _cmsClient$defaults2 === void 0 ? void 0 : _cmsClient$defaults2.baseURL) === "https://uat.loyalie.in") {
      // window.fbq("trackCustom", "DealsPage"); redo
    }
    ReactGA.ga("send", "pageview", "/deals");
  }, []);
  var debouncedScrollToTarget = useCallback(_.debounce(function (id) {
    scrollToTargetAdjusted(id);
  }, 1000), [scrollToTargetAdjusted]);
  useEffect(function () {
    if (searchInput.length > 0 && !isRewards) {
      if ((financeOffers === null || financeOffers === void 0 ? void 0 : financeOffers.length) > 0) {
        debouncedScrollToTarget("finance");
      } else if ((externalOffers === null || externalOffers === void 0 ? void 0 : externalOffers.length) > 0) {
        debouncedScrollToTarget("external");
      } else if ((bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.length) > 0) {
        debouncedScrollToTarget("bundle");
      } else if ((homeServicesOffers === null || homeServicesOffers === void 0 ? void 0 : homeServicesOffers.length) > 0) {
        debouncedScrollToTarget("homeServices");
      } else if ((homeFurnishingOffers === null || homeFurnishingOffers === void 0 ? void 0 : homeFurnishingOffers.length) > 0) {
        debouncedScrollToTarget("homeFurnishing");
      } else if ((electronicsOffers === null || electronicsOffers === void 0 ? void 0 : electronicsOffers.length) > 0) {
        debouncedScrollToTarget("electronics");
      } else if ((lifestyleOffers === null || lifestyleOffers === void 0 ? void 0 : lifestyleOffers.length) > 0) {
        debouncedScrollToTarget("lifestyle");
      } else if ((digitalAmenities === null || digitalAmenities === void 0 ? void 0 : digitalAmenities.length) > 0) {
        debouncedScrollToTarget("digital");
      } else {
        debouncedScrollToTarget("zeroDeal");
      }
    } else {
      debouncedScrollToTarget.cancel();
    }
  }, [searchInput, debouncedScrollToTarget, isRewards]);
  useEffect(function () {
    if (!isRewards) return;
    setTimeout(function () {
      var _location$state;
      var rewardsSection = document.getElementById("rewards");
      var categorySection = document.getElementById("reward-category");
      // if (rewards?.length > 0 && rewardsSection) {
      //     window.scrollTo({
      //         top: rewardsSection.offsetTop,
      //         behavior: 'smooth'
      //     });
      // }
      if ((rewards === null || rewards === void 0 ? void 0 : rewards.length) > 0 && rewardsSection) {
        var extraOffset = ((categorySection === null || categorySection === void 0 ? void 0 : categorySection.offsetHeight) || 0) * 2; // Increase visibility for all rows
        window.scrollTo({
          top: rewardsSection.offsetTop - extraOffset,
          behavior: "smooth"
        });
      } else if (noRewards) {
        debouncedScrollToTarget("NoRewards");
      } else if ((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.scrollTo) {
        debouncedScrollToTarget(location.state.scrollTo);
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);
  }, [isRewards, rewards, noRewards, location.state]);
  var checkKYCStatus = function checkKYCStatus() {
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "GET",
      url: "/winnre/user/user/kyc-status"
    }).then(function (message) {
      if (message.message == "COMPLETED") {
        history.push("/checkout".concat(isPoints ? "?isPoints=true" : ""));
      }
      if (message.message == "NOT_INITIATED" || message.message == "INITIATED" || message.message === "null" || message.message === "FAILED" || message.message == "PROCESSING") {
        checkKycVerificationStatus(false, true, false);
        setOpenKYCModal(true);
      }
    });
  };
  //FIROZ
  // useEffect(() => {
  //     console.log('check mate', selectedTag);
  //     if (selectedTag === null) {
  //         setOpenFilter(false);
  //     }

  //     getRewards();
  // }, [selectedTag]);

  var cartData;
  var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
  useEffect(function () {
    var _cartData;
    if (oldCartData) {
      cartData = JSON.parse(oldCartData);
    }
    if (isRewards && isRewardsLoaded && (rewards === null || rewards === void 0 ? void 0 : rewards.length) < 1 && ((_cartData = cartData) === null || _cartData === void 0 ? void 0 : _cartData.totalMrp) > 0 && (selectedRewardCategory == "" || !selectedRewardCategory) && (searchInput == "" || !searchInput)) {
      setNorewards(true);
    } else {
      setNorewards(false);
    }
  }, [isRewardsLoaded, rewards, history]);

  // To open kyc modal from cart checkout
  useEffect(function () {
    if (isKycModalEnabled) {
      setOpenKYCModal(true);
    }
  }, [isKycModalEnabled]);
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(internalWebview ? "mb-16" : "", " ").concat(config !== null && config !== void 0 && config.darkMode ? "bg-black" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white"), " relative ").concat(showAppDownload ? "pb-16" : ""),
    onClick: function onClick(event) {
      console.log("Click working");
      event.stopPropagation();
      if (dispatch && dealAction !== null && dealAction !== void 0 && dealAction.setCartModalVisible) {
        dispatch(dealAction.setCartModalVisible(false));
      }
    },
    style: {
      backgroundImage: "linear-gradient(90deg, rgba(".concat(config === null || config === void 0 || (_config$sectionBackgr = config.sectionBackground) === null || _config$sectionBackgr === void 0 ? void 0 : _config$sectionBackgr.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr2 = config.sectionBackground) === null || _config$sectionBackgr2 === void 0 ? void 0 : _config$sectionBackgr2.opacity, "), rgba(").concat(config === null || config === void 0 || (_config$sectionBackgr3 = config.sectionBackground) === null || _config$sectionBackgr3 === void 0 ? void 0 : _config$sectionBackgr3.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr4 = config.sectionBackground) === null || _config$sectionBackgr4 === void 0 ? void 0 : _config$sectionBackgr4.opacity, ")), url('").concat(config !== null && config !== void 0 && (_config$sectionBackgr5 = config.sectionBackground) !== null && _config$sectionBackgr5 !== void 0 && _config$sectionBackgr5.image ? config === null || config === void 0 || (_config$sectionBackgr6 = config.sectionBackground) === null || _config$sectionBackgr6 === void 0 ? void 0 : _config$sectionBackgr6.image : "", "')"),
      backgroundSize: "".concat(config !== null && config !== void 0 && (_config$sectionBackgr7 = config.sectionBackground) !== null && _config$sectionBackgr7 !== void 0 && _config$sectionBackgr7.size ? config === null || config === void 0 || (_config$sectionBackgr8 = config.sectionBackground) === null || _config$sectionBackgr8 === void 0 ? void 0 : _config$sectionBackgr8.size : "30% auto")
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "\n                    ".concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " w-full h-auto  "),
      children: (config === null || config === void 0 ? void 0 : config.header) && /*#__PURE__*/_jsx("div", {
        className: config === null || config === void 0 ? void 0 : config.header.headerClass
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "px-3 lg:pl-0 w-full lg:w-[95%] xl:w-[90%] lg:mx-auto py-5",
      children: [/*#__PURE__*/_jsx(Header, {
        searchValue: searchInput,
        isRewards: isRewards,
        isPoints: isPoints,
        onSearchChange: handleChange,
        internalWebview: internalWebview,
        userAccountSummary: userAccountSummary,
        claimNowHandler: claimNowHandler,
        kycStatus: kycStatus,
        config: config,
        appType: appType,
        redux: {
          dispatch: dispatch,
          isAuthenticated: isAuthenticated,
          authActions: authActions,
          dealAction: dealAction,
          internalWebview: internalWebview,
          showRewardsModal: showRewardsModal
        },
        router: {
          history: history,
          location: location
        },
        winnreAuth: winnreAuth
      }), isRewards && !isPoints && isAuthenticated && !noRewards && totalRewardspoint > 0 && /*#__PURE__*/_jsx("div", {
        id: "reward-category",
        className: "mt-2",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex items-start w-full lg:w-[90%]",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex flex-wrap gap-2 mt-4 overflow-x-auto overflow-y-visible",
            children: [rewardsCategoryList === null || rewardsCategoryList === void 0 ? void 0 : rewardsCategoryList.map(function (item, index) {
              return /*#__PURE__*/_jsx(CategoryDropdown, {
                category: item,
                isSelected: selectedRewardCategory === item.id,
                onCategoryClick: onClickCategoryFilter,
                onTagClick: onClickTagFilter,
                selectedTag: selectedTag,
                redux: {
                  isAuthenticated: isAuthenticated
                },
                winnreAuth: winnreAuth,
                cmsClient: cmsClient
              }, index);
            }), (selectedRewardCategory || selectedTag) && /*#__PURE__*/_jsxs("button", {
              onClick: function onClick() {
                handleCategorySelection(null);
                history.replace({
                  pathname: location.pathname
                });
              },
              className: "flex items-center gap-2 px-4 py-2 rounded-3xl border border-red-200 text-sm font-semibold bg-red-50 text-red-600 hover:bg-red-100 transition-colors ml-2",
              children: [/*#__PURE__*/_jsx("span", {
                children: "Clear Filters"
              }), /*#__PURE__*/_jsx(GrClose, {
                className: "w-4 h-4"
              })]
            })]
          })
        })
      }), isRewards && isAuthenticated && appType !== "winnre" && !isAdani(config) && !isReloy(config) && /*#__PURE__*/_jsx(AmazonWishlistInput, {
        isAuthenticated: isAuthenticated,
        winnreAuth: winnreAuth,
        isPoints: isPoints,
        appType: appType,
        redux: {
          dispatch: dispatch,
          dealAction: dealAction
        }
      }), isRewards && !isPoints && noRewards && /*#__PURE__*/_jsx(BasketFull, {
        checkKYCStatus: checkKYCStatus,
        redux: {
          dispatch: dispatch,
          dealAction: dealAction
        }
      }), /*#__PURE__*/_jsx("div", {
        id: "zeroDeal",
        children: searchInput.length > 0 && (bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.length) === 0 && !isLoadingBundle && (externalOffers === null || externalOffers === void 0 ? void 0 : externalOffers.length) === 0 && (homeServicesOffers === null || homeServicesOffers === void 0 ? void 0 : homeServicesOffers.length) === 0 && (homeFurnishingOffers === null || homeFurnishingOffers === void 0 ? void 0 : homeFurnishingOffers.length) === 0 && (lifestyleOffers === null || lifestyleOffers === void 0 ? void 0 : lifestyleOffers.length) === 0 && (electronicsOffers === null || electronicsOffers === void 0 ? void 0 : electronicsOffers.length) === 0 && (financeOffers === null || financeOffers === void 0 ? void 0 : financeOffers.length) === 0 && (digitalAmenities === null || digitalAmenities === void 0 ? void 0 : digitalAmenities.length) === 0 && !isLoadingHomeServices && !isLoadingHomeFurnishing && !isLoadingLifestyle && !isLoadingElectronics && !isLoadingFinance && !isLoadingDigital && !isRewards && /*#__PURE__*/_jsx(ZeroState, {
          type: "deals"
        })
      }), searchInput.length <= 0 && !isRewards && !isPoints && !isReloy(config) && /*#__PURE__*/_jsx(Vendors, {
        vendors: vendors,
        isRewards: isRewards,
        router: {
          history: history,
          location: location
        }
      }), searchInput.length <= 0 && !isRewards && !isPoints && !isReloy(config) && (config === null || config === void 0 ? void 0 : config.clientId) != "89f7c75cc7d56d4969a90431f3aa0bf6dff0f21e8656455ae0068483f578584a" && /*#__PURE__*/_jsx(DealsCategory, {
        className: "mt-4 ".concat(isRewards ? "lg:mt-7" : "lg:mt-8"),
        isRewards: isRewards,
        config: config,
        router: {
          history: history,
          location: location
        }
      }), isPoints && isAuthenticated && /*#__PURE__*/_jsx(CoinStoreHeader, {
        config: config
      }), isPoints && isAuthenticated && /*#__PURE__*/_jsx(HowToEarnCoins, {
        config: config
      }), (isLoadingTopDeals || isLoadingFinance || isLoadingLifestyle || isLoadingrewards) && /*#__PURE__*/_jsx(SkeletonDealPage, {
        isVisible: true
      }), isAuthenticated && (bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.length) > 0 && !isLoadingBundle && !isRewards && !(config !== null && config !== void 0 && (_config$deals = config.deals) !== null && _config$deals !== void 0 && _config$deals.disableBundleDeals) && /*#__PURE__*/_jsx("div", {
        id: "bundle",
        children: /*#__PURE__*/_jsx(BundleOffers, {
          bundleOffers: bundleOffers,
          config: config,
          redux: {
            dispatch: dispatch,
            isAuthenticated: isAuthenticated,
            authActions: authActions,
            userId: redux === null || redux === void 0 ? void 0 : redux.userId,
            userMobile: redux === null || redux === void 0 ? void 0 : redux.userMobile,
            clientWebview: redux === null || redux === void 0 ? void 0 : redux.clientWebview,
            internalWebview: internalWebview,
            // pass through any nested structures if needed
            webView: redux === null || redux === void 0 ? void 0 : redux.webView,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth,
            userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails
          },
          router: {
            history: history,
            location: location
          },
          winnreAuth: winnreAuth,
          cmsClient: cmsClient
        })
      }), searchInput.length <= 0 && (topOffers === null || topOffers === void 0 ? void 0 : topOffers.length) > 0 && /*#__PURE__*/_jsx(DealSection, {
        type: "OFFERS OF THE MONTH",
        offers: topOffers,
        isRewards: isRewards,
        isPoints: isPoints,
        className: "",
        router: {
          history: history,
          location: location
        },
        config: config,
        appType: appType,
        redux: {
          dispatch: dispatch,
          isAuthenticated: isAuthenticated,
          authActions: authActions,
          dealAction: dealAction,
          auth: redux === null || redux === void 0 ? void 0 : redux.auth,
          webView: redux === null || redux === void 0 ? void 0 : redux.webView,
          userId: redux === null || redux === void 0 ? void 0 : redux.userId,
          userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
          totalRewardspoint: totalRewardspoint
        },
        winnreAuth: winnreAuth,
        winnreNoAuth: winnreNoAuth,
        cmsClient: cmsClient
      }), !isRewards && (homeServicesOffers === null || homeServicesOffers === void 0 ? void 0 : homeServicesOffers.length) > 0 && /*#__PURE__*/_jsx("div", {
        id: "homeServices",
        children: /*#__PURE__*/_jsx(DealSection, {
          type: "Home Services",
          isRewards: isRewards,
          isPoints: isPoints,
          offers: homeServicesOffers,
          className: "mt-8 lg:mt-16",
          router: {
            history: history,
            location: location
          },
          config: config,
          appType: appType,
          redux: {
            dispatch: dispatch,
            isAuthenticated: isAuthenticated,
            authActions: authActions,
            dealAction: dealAction,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth,
            webView: redux === null || redux === void 0 ? void 0 : redux.webView,
            userId: redux === null || redux === void 0 ? void 0 : redux.userId,
            userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
            totalRewardspoint: totalRewardspoint
          },
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        })
      }), !isRewards && (homeFurnishingOffers === null || homeFurnishingOffers === void 0 ? void 0 : homeFurnishingOffers.length) > 0 && /*#__PURE__*/_jsx("div", {
        id: "homeFurnishing",
        children: /*#__PURE__*/_jsx(DealSection, {
          type: "Home Furnishings",
          isRewards: isRewards,
          isPoints: isPoints,
          offers: homeFurnishingOffers,
          className: "mt-8 lg:mt-16",
          router: {
            history: history,
            location: location
          },
          config: config,
          appType: appType,
          redux: {
            dispatch: dispatch,
            isAuthenticated: isAuthenticated,
            authActions: authActions,
            dealAction: dealAction,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth,
            webView: redux === null || redux === void 0 ? void 0 : redux.webView,
            userId: redux === null || redux === void 0 ? void 0 : redux.userId,
            userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
            totalRewardspoint: totalRewardspoint
          },
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        })
      }), !isRewards && (lifestyleOffers === null || lifestyleOffers === void 0 ? void 0 : lifestyleOffers.length) > 0 && !isReloy(config) && /*#__PURE__*/_jsx("div", {
        id: "lifestyle",
        children: /*#__PURE__*/_jsx(DealSection, {
          type: "Lifestyle",
          isRewards: isRewards,
          isPoints: isPoints,
          offers: lifestyleOffers,
          className: "mt-8 lg:mt-16",
          router: {
            history: history,
            location: location
          },
          config: config,
          appType: appType,
          redux: {
            dispatch: dispatch,
            isAuthenticated: isAuthenticated,
            authActions: authActions,
            dealAction: dealAction,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth,
            webView: redux === null || redux === void 0 ? void 0 : redux.webView,
            userId: redux === null || redux === void 0 ? void 0 : redux.userId,
            userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
            totalRewardspoint: totalRewardspoint
          },
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        })
      }), !isRewards && (electronicsOffers === null || electronicsOffers === void 0 ? void 0 : electronicsOffers.length) > 0 && /*#__PURE__*/_jsx("div", {
        id: "electronics",
        children: /*#__PURE__*/_jsx(DealSection, {
          type: "Electronics",
          isRewards: isRewards,
          isPoints: isPoints,
          offers: electronicsOffers,
          className: "mt-8 lg:mt-16",
          router: {
            history: history,
            location: location
          },
          config: config,
          appType: appType,
          redux: {
            dispatch: dispatch,
            isAuthenticated: isAuthenticated,
            authActions: authActions,
            dealAction: dealAction,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth,
            webView: redux === null || redux === void 0 ? void 0 : redux.webView,
            userId: redux === null || redux === void 0 ? void 0 : redux.userId,
            userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
            totalRewardspoint: totalRewardspoint
          },
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        })
      }), !isRewards && (financeOffers === null || financeOffers === void 0 ? void 0 : financeOffers.length) > 0 && /*#__PURE__*/_jsx("div", {
        id: "finance",
        children: /*#__PURE__*/_jsx(DealSection, {
          type: "Finance",
          isRewards: isRewards,
          isPoints: isPoints,
          offers: financeOffers,
          className: "mt-8 lg:mt-16",
          router: {
            history: history,
            location: location
          },
          config: config,
          appType: appType,
          redux: {
            dispatch: dispatch,
            isAuthenticated: isAuthenticated,
            authActions: authActions,
            dealAction: dealAction,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth,
            webView: redux === null || redux === void 0 ? void 0 : redux.webView,
            userId: redux === null || redux === void 0 ? void 0 : redux.userId,
            userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
            totalRewardspoint: totalRewardspoint
          },
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        })
      }), searchInput.length <= 0 && (externalOffers === null || externalOffers === void 0 ? void 0 : externalOffers.length) > 0 && /*#__PURE__*/_jsx(DealSection, {
        type: "CURATED OFFERS",
        offers: externalOffers.slice(0, 8),
        isRewards: isRewards,
        isPoints: isPoints,
        className: "mt-8 lg:mt-16",
        router: {
          history: history,
          location: location
        },
        config: config,
        appType: appType,
        redux: {
          dispatch: dispatch,
          isAuthenticated: isAuthenticated,
          authActions: authActions,
          dealAction: dealAction,
          auth: redux === null || redux === void 0 ? void 0 : redux.auth,
          webView: redux === null || redux === void 0 ? void 0 : redux.webView,
          userId: redux === null || redux === void 0 ? void 0 : redux.userId,
          userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
          totalRewardspoint: totalRewardspoint
        },
        winnreAuth: winnreAuth,
        winnreNoAuth: winnreNoAuth,
        cmsClient: cmsClient
      }), isRewards && (rewards === null || rewards === void 0 ? void 0 : rewards.length) > 0 && /*#__PURE__*/_jsx("div", {
        id: "rewards",
        children: /*#__PURE__*/_jsx(DealSection, {
          type: isPoints ? "Redeem Rewards" : "Explore the products you’re eligible for!",
          subHeading: isPoints ? isReloy(config) ? "Use your points to redeem a curated selection of rewards, ranging from home essentials and electronics to gift vouchers, in the HT Points Store" : "Use your coins to redeem a curated selection of rewards, ranging from home essentials and electronics to gift vouchers, in the Coins Store" : "Choose from a wide range of products that match your lifestyle.",
          isRewards: isRewards,
          isPoints: isPoints,
          offers: rewards,
          className: isPoints ? 'pt-12' : 'mt-4 lg:mt-6',
          router: {
            history: history,
            location: location
          },
          config: config,
          redux: {
            dispatch: dispatch,
            isAuthenticated: isAuthenticated,
            authActions: authActions,
            dealAction: dealAction,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth,
            webView: redux === null || redux === void 0 ? void 0 : redux.webView,
            userId: redux === null || redux === void 0 ? void 0 : redux.userId,
            userDetails: redux === null || redux === void 0 ? void 0 : redux.userDetails,
            totalRewardspoint: totalRewardspoint,
            deals: deals,
            deal: deals
          },
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        })
      }), !isLoadingrewards && currentPage < totalPages && isPoints && /*#__PURE__*/_jsx("div", {
        className: " flex justify-center pt-10",
        children: /*#__PURE__*/_jsx("button", {
          onClick: loadMoreHandler,
          className: "flex items-center justify-center gap-x-2 mx-auto px-6 py-2 text-lg text-bold ".concat(config !== null && config !== void 0 && config.darkTheme ? "text-black border-[1px] border-black" : "text-white bg-primary"),
          children: /*#__PURE__*/_jsx(_Fragment, {
            children: "VIEW MORE"
          })
        })
      }), isRewards && !isLoadingrewards && (rewards === null || rewards === void 0 ? void 0 : rewards.length) == 0 && (totalRewardspoint == 0 || isNaN(totalRewardspoint)) && appType !== "winnre" && /*#__PURE__*/_jsx(ZeroRewardPoints, {
        isMobile: isMobile,
        router: {
          history: history,
          location: location
        },
        redux: {
          webView: redux === null || redux === void 0 ? void 0 : redux.webView
        },
        appType: appType,
        config: config
      }), isPoints && isAuthenticated && /*#__PURE__*/_jsx(RedeemSteps, {
        config: config
      }), isRewards && isAuthenticated && /*#__PURE__*/_jsx(FAQSection, {
        claimNowHandler: claimNowHandler,
        isPoints: isPoints,
        userAccountSummary: userAccountSummary,
        kycStatus: kycStatus,
        config: config
      }), !isRewards && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          className: "bg-[#FFEBCF] text-sm md:text-md font-medium text-secondary-focus p-4 lg:p-5 mt-12 ".concat(isAdani(config) && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontBody) || '' : getFont((config === null || config === void 0 ? void 0 : config.name).toUpperCase()).body),
          children: "Not finding what you need? Share your wishlist with us and we may soon make it live!"
        }), /*#__PURE__*/_jsx("p", {
          className: "flex mx-auto text-center items-center w-[75%] text-primary z-10 pb-6 leading-5 justify-center text-sm mt-8 ".concat(isAdani(config) && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontBody) || '' : getFont((config === null || config === void 0 ? void 0 : config.name).toUpperCase()).body, " "),
          children: "*By clicking on Redeem Now, you authorize RELOY and partner brands to contact you via WhatsApp, SMS, phone, email etc. All brands have their respective terms and conditions  ".concat(isReloy(config) ? ", and Reloy shall not be held" : "neither Reloy nor ".concat(config === null || config === void 0 ? void 0 : config.fullName, " will be"), "  responsible in case of any concerns. ")
        })]
      })]
    }), isRewards && openKYCModal && /*#__PURE__*/_jsx(KYCModal, {
      visible: openKYCModal,
      onClick: closeModal,
      userAccountSummary: userAccountSummary,
      getUserAccountSummary: getUserAccountSummary,
      setOpenKYCModal: setOpenKYCModal,
      closeKYCModal: closeModal,
      step: step,
      setStep: setStep,
      checkKycVerificationStatus: checkKycVerificationStatus,
      loading: loading,
      checkBankVerificationStatus: checkBankVerificationStatus,
      isUpdateWorkflow: isUpdateWorkflow,
      isKycCompleted: isKycCompleted,
      initiateWorkflow: initiateWorkflow,
      claimInProgress: claimInProgress,
      rewardTypeSelected: rewardTypeSelected,
      cashOutFlow: cashOutFlow,
      setClaimInProgress: setClaimInProgress,
      bankstatus: bankstatus,
      isKycFailed: isKycFailed,
      isBankVerificationFailed: isBankVerificationFailed,
      isKycProcessing: isKycProcessing,
      router: {
        history: history,
        location: location
      },
      config: config,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth,
      cmsClient: cmsClient,
      isPoints: isPoints
    }), isRewards && showRewardsModal && /*#__PURE__*/_jsx(RewardsPopupModal, {
      redux: {
        dispatch: dispatch,
        dealAction: dealAction,
        showRewardsModal: showRewardsModal
      },
      router: {
        history: history
      },
      isPoints: isPoints
    })]
  });
}
export default DealsAndDiscounts;